import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type Theme = 'dark' | 'light';

interface UiState {
  theme: Theme;
  setTheme: (theme: Theme) => void;
}

export const useUiStore = create<UiState>()(
  persist(
    (set) => ({
      theme: 'dark',
      setTheme: (theme) => {
        document.documentElement.dataset.theme = theme;
        set({ theme });
      },
    }),
    { name: 'ui-preferences' },
  ),
);

export function applyStoredTheme() {
  const stored = localStorage.getItem('ui-preferences');
  try {
    const parsed = stored ? (JSON.parse(stored) as { state?: { theme?: Theme } }) : null;
    const theme = parsed?.state?.theme ?? 'dark';
    document.documentElement.dataset.theme = theme;
  } catch {
    document.documentElement.dataset.theme = 'dark';
  }
}
